import type { SVGProps } from "react";
const SvgTopWhiskerSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    {...props}
  >
    <g clipPath="url(#Top_Whisker_SVG_svg__a)">
      <path stroke="#103976" d="M16.5 26V8M23 8.5H10" />
      <path fill="#CFD7E4" stroke="#103976" d="M4.5 26.5h24v19h-24z" />
      <path fill="#D2D2D2" fillOpacity={0.84} d="M4 26h25v36H4z" />
    </g>
    <defs>
      <clipPath id="Top_Whisker_SVG_svg__a">
        <path fill="#fff" d="M0 0h33v33H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTopWhiskerSvg;
